import { Directive } from '@angular/core';

import { classes } from '../../../utils/src';

@Directive({
  selector: '[knxAlertTitle]',
  host: {
    'data-slot': 'alert-title',
  },
})
export class KnxAlertTitle {
  constructor() {
    classes(
      () =>
        '[&_a]:hover:text-foreground font-medium group-has-[>ng-icon]/alert:col-start-2 [&_a]:underline [&_a]:underline-offset-3',
    );
  }
}
